// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PolicyPage_body_4__I9tUm {
    color: #fff;
    background-color: #040404;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.2;
  }

.PolicyPage_div_block_54__eA7Sa {
    grid-column-gap: 1vw;
    grid-row-gap: 1vw;
    flex-flow: column;
    display: flex;
  }

  .PolicyPage_text_block_32__l3DnQ {
    font-size: 2rem;
  }
  .PolicyPage_text_block_33__Pc9Gf {
    color: #fff;
    font-size: 1vw;
}

.PolicyPage_link_5__dAZxN {
  color: #0094ff;
}
.PolicyPage_link_6__zE4DD {
  color: #0094ff;
}

.PolicyPage_list__r9FiE {
  grid-column-gap: 1vw;
  grid-row-gap: 1vw;
  flex-flow: column;
  margin-top: 0;
  margin-bottom: 0;
  display: flex;
}
.PolicyPage_text_block_33__Pc9Gf, .PolicyPage_list_item_4__JpZm-, .PolicyPage_list_item_5__CBv3C, .PolicyPage_list_item_6__HypwJ {
    font-size: 1rem;
}

.PolicyPage_div_block_51__z8D-M {
    grid-column-gap: 2.2vw;
    grid-row-gap: 2.2vw;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
    display: flex;
}

.PolicyPage_div_block_52__b2QiW {
    grid-column-gap: 2vw;
    grid-row-gap: 2vw;
    flex-flow: column;
    width: auto;
    display: flex;
}

.PolicyPage_div_block_51__z8D-M, .PolicyPage_div_block_52__b2QiW {
    grid-column-gap: 2rem;
    grid-row-gap: 2rem;
}

.PolicyPage_heading_15__qg\\+5F {
    color: #fff;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 12vw;
    font-weight: 900;
    line-height: 1;
}
@media screen and (max-width: 479px) {
.PolicyPage_heading_15__qg\\+5F {
    font-size: 5rem;
}
}

.PolicyPage_section_6__TDpB8 {
    padding-top: 15vh;
    padding-bottom: 10vh;
}

.PolicyPage_text_block_35__cisWk {
    font-size: 16px;
    font-weight: 500;
}

.PolicyPage_heading_16__cSw67 {
    color: #fff;
    text-align: left;
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 4.4vw;
    line-height: 1.2;
}

.PolicyPage_heading_16__cSw67 {
    font-size: 3rem;
}


  .PolicyPage_text_block_34__OOiK9 {
    color: silver;
    font-size: 1vw;
  }

  .PolicyPage_text_block_34__OOiK9 {
    font-size: 1rem;
  }

  .PolicyPage_text_block_30__S\\+fS- {
    color: #fff;
    text-align: left;
    font-size: 1vw;
  }
  .PolicyPage_text_block_30__S\\+fS- {
    font-size: 1rem;
  }

  .PolicyPage_text_block_32__l3DnQ {
    color: #fff;
    font-size: 2vw;
    font-weight: 600;
  }

  .PolicyPage_text_block_32__l3DnQ {
    font-size: 2rem;
  }

  .PolicyPage_w_layout_blockcontainer__IvPsy {
    max-width: 940px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
  
  @media screen and (max-width: 991px) {
    .PolicyPage_w_layout_blockcontainer__IvPsy {
      max-width: 728px;
    }
  }
  
  @media screen and (max-width: 767px) {
    .PolicyPage_w_layout_blockcontainer__IvPsy {
      max-width: none;
    }
  }

  .PolicyPage_w_container__ejsxC {
    margin-left: auto;
    margin-right: auto;
    max-width: 940px;
  }
  .PolicyPage_w_container__ejsxC:before,
  .PolicyPage_w_container__ejsxC:after {
    content: " ";
    display: table;
    grid-column-start: 1;
    grid-row-start: 1;
    grid-column-end: 2;
    grid-row-end: 2;
  }
  .PolicyPage_w_container__ejsxC:after {
    clear: both;
  }
  .PolicyPage_w_container__ejsxC .PolicyPage_w_row__O2-aK {
    margin-left: -10px;
    margin-right: -10px;
  }

  @media screen and (max-width: 991px) {
    .PolicyPage_w_container__ejsxC {
      max-width: 728px;
    }
    .PolicyPage_w_container__ejsxC .PolicyPage_w_row__O2-aK {
        margin-left: 0;
        margin-right: 0;
      }
}
@media screen and (max-width: 479px) {
    .PolicyPage_w_container__ejsxC {
      max-width: none;
    }
}

.PolicyPage_container_14__5ShYI {
  width: 100%;
  max-width: 80vw;
  padding-left: 3.3vw;
  padding-right: 3.3vw;
}`, "",{"version":3,"sources":["webpack://./src/pages/UtilityPages/Policy/PolicyPage.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;AAEF;IACI,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,cAAc;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;AACA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;AACA;IACI,eAAe;AACnB;AACA;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;;EAGE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,eAAe;IACjB;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;;IAEE,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE;MACE,gBAAgB;IAClB;IACA;QACI,cAAc;QACd,eAAe;MACjB;AACN;AACA;IACI;MACE,eAAe;IACjB;AACJ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":[".body_4 {\n    color: #fff;\n    background-color: #040404;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 1.2;\n  }\n\n.div_block_54 {\n    grid-column-gap: 1vw;\n    grid-row-gap: 1vw;\n    flex-flow: column;\n    display: flex;\n  }\n\n  .text_block_32 {\n    font-size: 2rem;\n  }\n  .text_block_33 {\n    color: #fff;\n    font-size: 1vw;\n}\n\n.link_5 {\n  color: #0094ff;\n}\n.link_6 {\n  color: #0094ff;\n}\n\n.list {\n  grid-column-gap: 1vw;\n  grid-row-gap: 1vw;\n  flex-flow: column;\n  margin-top: 0;\n  margin-bottom: 0;\n  display: flex;\n}\n.text_block_33, .list_item_4, .list_item_5, .list_item_6 {\n    font-size: 1rem;\n}\n\n.div_block_51 {\n    grid-column-gap: 2.2vw;\n    grid-row-gap: 2.2vw;\n    flex-flow: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    display: flex;\n}\n\n.div_block_52 {\n    grid-column-gap: 2vw;\n    grid-row-gap: 2vw;\n    flex-flow: column;\n    width: auto;\n    display: flex;\n}\n\n.div_block_51, .div_block_52 {\n    grid-column-gap: 2rem;\n    grid-row-gap: 2rem;\n}\n\n.heading_15 {\n    color: #fff;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 12vw;\n    font-weight: 900;\n    line-height: 1;\n}\n@media screen and (max-width: 479px) {\n.heading_15 {\n    font-size: 5rem;\n}\n}\n\n.section_6 {\n    padding-top: 15vh;\n    padding-bottom: 10vh;\n}\n\n.text_block_35 {\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.heading_16 {\n    color: #fff;\n    text-align: left;\n    margin-top: 0;\n    margin-bottom: 16px;\n    font-size: 4.4vw;\n    line-height: 1.2;\n}\n\n.heading_16 {\n    font-size: 3rem;\n}\n\n\n  .text_block_34 {\n    color: silver;\n    font-size: 1vw;\n  }\n\n  .text_block_34 {\n    font-size: 1rem;\n  }\n\n  .text_block_30 {\n    color: #fff;\n    text-align: left;\n    font-size: 1vw;\n  }\n  .text_block_30 {\n    font-size: 1rem;\n  }\n\n  .text_block_32 {\n    color: #fff;\n    font-size: 2vw;\n    font-weight: 600;\n  }\n\n  .text_block_32 {\n    font-size: 2rem;\n  }\n\n  .w_layout_blockcontainer {\n    max-width: 940px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n  }\n  \n  @media screen and (max-width: 991px) {\n    .w_layout_blockcontainer {\n      max-width: 728px;\n    }\n  }\n  \n  @media screen and (max-width: 767px) {\n    .w_layout_blockcontainer {\n      max-width: none;\n    }\n  }\n\n  .w_container {\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 940px;\n  }\n  .w_container:before,\n  .w_container:after {\n    content: \" \";\n    display: table;\n    grid-column-start: 1;\n    grid-row-start: 1;\n    grid-column-end: 2;\n    grid-row-end: 2;\n  }\n  .w_container:after {\n    clear: both;\n  }\n  .w_container .w_row {\n    margin-left: -10px;\n    margin-right: -10px;\n  }\n\n  @media screen and (max-width: 991px) {\n    .w_container {\n      max-width: 728px;\n    }\n    .w_container .w_row {\n        margin-left: 0;\n        margin-right: 0;\n      }\n}\n@media screen and (max-width: 479px) {\n    .w_container {\n      max-width: none;\n    }\n}\n\n.container_14 {\n  width: 100%;\n  max-width: 80vw;\n  padding-left: 3.3vw;\n  padding-right: 3.3vw;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body_4": `PolicyPage_body_4__I9tUm`,
	"div_block_54": `PolicyPage_div_block_54__eA7Sa`,
	"text_block_32": `PolicyPage_text_block_32__l3DnQ`,
	"text_block_33": `PolicyPage_text_block_33__Pc9Gf`,
	"link_5": `PolicyPage_link_5__dAZxN`,
	"link_6": `PolicyPage_link_6__zE4DD`,
	"list": `PolicyPage_list__r9FiE`,
	"list_item_4": `PolicyPage_list_item_4__JpZm-`,
	"list_item_5": `PolicyPage_list_item_5__CBv3C`,
	"list_item_6": `PolicyPage_list_item_6__HypwJ`,
	"div_block_51": `PolicyPage_div_block_51__z8D-M`,
	"div_block_52": `PolicyPage_div_block_52__b2QiW`,
	"heading_15": `PolicyPage_heading_15__qg+5F`,
	"section_6": `PolicyPage_section_6__TDpB8`,
	"text_block_35": `PolicyPage_text_block_35__cisWk`,
	"heading_16": `PolicyPage_heading_16__cSw67`,
	"text_block_34": `PolicyPage_text_block_34__OOiK9`,
	"text_block_30": `PolicyPage_text_block_30__S+fS-`,
	"w_layout_blockcontainer": `PolicyPage_w_layout_blockcontainer__IvPsy`,
	"w_container": `PolicyPage_w_container__ejsxC`,
	"w_row": `PolicyPage_w_row__O2-aK`,
	"container_14": `PolicyPage_container_14__5ShYI`
};
export default ___CSS_LOADER_EXPORT___;
